module.exports = "/images/Ico-veicoli-industriali.svg?e485eea13101bef8b48adebaff663e02";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/Ico-veicoli-industriali.svg
// module id = aoIa
// module chunks = 1